module.exports = __webpack_public_path__ + "assets/img/th-484e214a.png";